export default {"src":"/_next/static/media/CNAE.a890a8c2.svg","height":511,"width":339,"blurWidth":0,"blurHeight":0};